import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMfrFeedDoorOpening = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.12652 13.702C7.41941 13.4091 7.41941 12.9342 7.12652 12.6413L5.0052 10.52C4.7123 10.2271 4.23743 10.2271 3.94454 10.52L1.82322 12.6413C1.53032 12.9342 1.53032 13.4091 1.82322 13.702C2.11611 13.9948 2.59098 13.9948 2.88388 13.702L3.72487 12.861V16C3.72487 16.4143 4.06065 16.75 4.47487 16.75C4.88908 16.75 5.22487 16.4143 5.22487 16V12.861L6.06586 13.702C6.35875 13.9948 6.83362 13.9948 7.12652 13.702Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.1489 3.46099C14.1966 2.9467 14.6281 2.55334 15.1446 2.55334H18.2653C18.5607 2.55334 18.841 2.68396 19.031 2.91016C19.221 3.13635 19.3013 3.43499 19.2503 3.72596L19.0476 4.8824H21C21.2956 4.8824 21.5761 5.01322 21.7661 5.23973C21.9561 5.46623 22.0362 5.7652 21.9848 6.05633L20.3027 15.5796L21.1245 19.8093C21.1815 20.1025 21.1044 20.4057 20.9145 20.6362C20.7245 20.8666 20.4415 21 20.1429 21H9.85715C9.55852 21 9.27551 20.8666 9.08555 20.6362C8.89559 20.4057 8.81855 20.1025 8.8755 19.8093L9.69728 15.5796L8.01524 6.05633C7.96382 5.7652 8.04386 5.46623 8.23387 5.23973C8.42387 5.01322 8.70436 4.8824 9 4.8824H14.017L14.1489 3.46099ZM13.8443 6.8824H10.1921L11.5531 14.5883H13.2205L13.8443 6.8824ZM17.4606 14.5883H18.4469L19.8079 6.8824H18.7083L17.4606 14.5883ZM18.4613 16.5883H11.5387L11.0701 19H18.9299L18.4613 16.5883ZM16.1489 10.1765L16.8721 5.70977L17.0748 4.55334H16.0561L15.9248 5.96892L15.5842 10.1765H16.1489Z",
		fill: "currentColor"
	})]
});
export default SvgMfrFeedDoorOpening;
